class bundleBuilder extends HTMLElement {
  constructor () {
    super();
    const options = document.querySelectorAll('variant-radios input[type="radio"]')
    const parentData = JSON.parse(document.getElementById('parentJSON').textContent)
    const variantList = document.getElementById('variantList') ? JSON.parse(document.getElementById('variantList').textContent) : false
    const groupForm = document.getElementById('parentItemForm')
    const optionFields = document.querySelector('product-variants') ? Array.from(document.querySelector('product-variants').querySelectorAll('fieldset')) : null
    const productsInBundle = []
  }
}
const options = document.querySelectorAll('variant-radios input[type="radio"]')
const parentData = JSON.parse(document.getElementById('parentJSON').textContent)
const variantList = document.getElementById('variantList') ? JSON.parse(document.getElementById('variantList').textContent) : false
const groupForm = document.getElementById('parentItemForm')
const optionFields = document.querySelector('product-variants') ? Array.from(document.querySelector('product-variants').querySelectorAll('fieldset')) : null
const atcButton = document.querySelector('.btn_commoncls');
const productsInBundle = []
const onlyID = []
let priceFlat;
let priceWVA;
parentData.forEach((item) => {
  productsInBundle.push(item.item.childrenID)
  item.item.childrenID.forEach((child) => {
    onlyID.push(parseInt(child.split(':')[0]))
  })
})
document.querySelector('product-variants') ?
  Array.from(document.querySelector('product-variants').querySelectorAll('fieldset')).forEach((field) => {
    const selection = Array.from(field.querySelectorAll('label'))
    selection.forEach((option) => {
      option.addEventListener('click', function () {
        console.log(option.getAttribute('data-name'))
      })
    })
  }) : null

document.querySelector('product-variants') ?
  Array.from(document.querySelector('product-variants').querySelectorAll('fieldset')).forEach((field) => {
    const selection = Array.from(field.querySelectorAll('label'))
    selection.forEach((option) => {
      option.addEventListener('click', function () {
        console.log(option.getAttribute('data-name'))
      })
    })
  }) : null

const componentVariants = variantList ? variantList.filter((product) => 
  onlyID.some(check => product.id === check)
) : null

let tcombo = '';
const tchecked = optionFields?.length > 1 ? 
  Array.from(options).filter(checkbox => checkbox.checked).slice(0, -1) : Array.from(options).filter(checkbox => checkbox.checked)
tchecked.forEach((ops) => {
  tcombo += `${ops.defaultValue} `
})

optionFields?.slice(0, -1).forEach((field) => {
  field.querySelectorAll('input[type="radio"]').forEach((option) => {
    option.addEventListener('change', function () {
      let newCombo;
      const radios = optionFields.slice(0, -1).flatMap(field => 
        Array.from(field.querySelectorAll('input[type="radio"]'))
      );
      const selectedRadio = radios.filter(checkbox => checkbox.checked);
      selectedRadio.forEach((radio) => {
        newCombo += `${radio.value} `
      })
      newCombo = newCombo.replace('undefined', '')

      optionFields[optionFields.length - 1].querySelectorAll('label').forEach((option) => {
        console.log(`${newCombo.trim().toLowerCase()} ${option.getAttribute('data-name').replace('-', ' ')}`)
        const valueData = JSON.parse(document.getElementById('parentJSON').textContent).filter((item) =>
          item.item?.configuration.toLowerCase() == `${newCombo.trim().toLowerCase()} ${optionFields.length > 1 ? option.getAttribute('data-name').replace('-', ' ') : ''}`
        );
        console.log(valueData)
        if (valueData[0]?.item) {
          valueData[0].item.childrenID = valueData[0].item.childrenID.map(id => parseInt(id.split(':')[0]));
          const selectedOption = {
            config: option.getAttribute('data-name'),
            variants: componentVariants.filter((component) =>
              valueData[0].item.childrenID.includes(component.id)
            ),
            itemQuants: JSON.parse(document.getElementById('parentJSON').textContent).filter((item) =>
              item.item?.configuration.toLowerCase() == `${newCombo.trim().toLowerCase()} ${optionFields.length > 1 ? option.getAttribute('data-name').replace('-', ' ') : ''}`
            )[0].item.childrenID
          }
          const itemQuantsMap = selectedOption.itemQuants.reduce((acc, item) => {
            const [id, quant] = item.split(':');
              acc[id] = parseInt(quant, 10);
              return acc;
          }, {});
          const combinedVariants = selectedOption.variants.map(variant => {
            const idStr = variant.id.toString();
            const itemQuant = itemQuantsMap[idStr] || 0;
            return {
              ...variant,
              bundlesAvailable: variant.quantity / itemQuant,
              itemQuant:  itemQuant,
              quantity: variant.quantity
            };
          });

          if (combinedVariants.some(item => item.bundlesAvailable < 1)) {
            console.log(`${option.getAttribute('data-name')} out of stock`)
            option.style.pointerEvents = 'none';
            option.style.opacity = '0.5';
            option.style.cursor = 'not-allowed'
          } else {
            console.log(`${option.getAttribute('data-name')} in stock`)
            option.style.pointerEvents = 'unset';
            option.style.opacity = '1';
            option.style.cursor = 'pointer'
          }
          
          // if (selectedOption.variants.some((variant) => Number(variant.preorderQuant) > 0)) {
          //   atcButton.innerHTML = 'PREORDER'
          //   document.querySelector('#product-form-installment').style.display = 'none'
          //   document.querySelector('.preorder-text').classList.remove('hidden')
          //   document.querySelector('.preorder-text').innerHTML = `Orders placed on ${new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })} will start shipping by January 14, 2025. If already purchased refer to your order confirmation for ship date.`
          // } else {
          //   atcButton.innerHTML = 'ADD TO CART'
          //   document.querySelector('.preorder-text').classList.add('hidden')
          // }
        } 
      })
    });
  });
});

if (optionFields != null && variantList) {
  optionFields[optionFields.length - 1].querySelectorAll('label').forEach((option) => {
    const valueData = parentData.filter((item) =>
      item.item?.configuration.toLowerCase() == `${optionFields.length > 1 ? tcombo.trim().toLowerCase() : ''} ${option.getAttribute('data-name').replace('-', ' ')}`.trim()
    );
    if (valueData[0]?.item != undefined) {
      valueData[0].item.childrenID = valueData[0].item.childrenID.map(id => parseInt(id.split(':')[0]));
      const selectedOption = {
        config: option.getAttribute('data-name'),
        variants: componentVariants.filter((component) =>
          valueData[0].item.childrenID.includes(component.id)
        ),
        itemQuants: JSON.parse(document.getElementById('parentJSON').textContent).filter((item) =>
          item.item?.configuration.toLowerCase().includes(option.getAttribute('data-name').replace('-', ' '))
        )[0].item.childrenID
      }
      console.log(selectedOption)
      const itemQuantsMap = selectedOption.itemQuants.reduce((acc, item) => {
        const [id, quant] = item.split(':');
          acc[id] = parseInt(quant, 10);
          return acc;
      }, {});
      const combinedVariants = selectedOption.variants.map(variant => {
        const idStr = variant.id.toString();
        const itemQuant = itemQuantsMap[idStr] || 0;
        return {
            ...variant,
            bundlesAvailable: variant.quantity / itemQuant
        };
      });

      console.log(selectedOption)
      console.log(combinedVariants)

      if (combinedVariants.some(item => item.bundlesAvailable < 1)) {
        console.log(`${option.getAttribute('data-name')} out of stock`)
        option.style.pointerEvents = 'none';
        option.style.opacity = '0.5';
        option.style.cursor = 'not-allowed';
      } else {
        console.log(`${option.getAttribute('data-name')} in stock`)
      }
    }
  })
}

groupForm.addEventListener('submit', async (e) => {
  e.preventDefault();
  let combo = '';
  const checked = Array.from(options).filter(checkbox => checkbox.checked)
  priceFlat =  document.querySelector('span.price-item').getAttribute('data-affirm');
  priceWVAT = parseInt(priceFlat);
  let groupData = [];
  checked.forEach((ops) => {
    combo += ` ${ops.defaultValue}`
  })
  
  combo = combo.trim()
  JSON.parse(document.getElementById('parentJSON').textContent).forEach((item) => {
    console.log(item)
    if(combo == item.item?.configuration) {
      item.item.childrenID.forEach((child) => {
        const shipDate = document.querySelector('#preorder-input')?.value || null;
        groupData.push({
          id:parseInt(child.split(':')[0]),
          quantity: parseInt(child.split(':')[1]),
          properties: {
            _bundleId: item.item.parentID,
            _parentSKU:item.item.parentSKU,
            _priceCorrection: `${priceWVAT}:${item.item.price.toString().includes(':') ? item.item.price.split(':')[1] : '1'}`,
            _originalQuant: parseInt(child.split(':')[1]),
            ...(shipDate && { "Ship Date": shipDate }),
            _bundleData: {
              id:parseInt(child.split(':')[0]),
              quantity: parseInt(child.split(':')[1]),
              properties: {
                _bundleId: item.item.parentID,
                _parentSKU:item.item.parentSKU,
                _priceCorrection: `${priceWVAT}:${item.item.price.toString().includes(':') ? item.item.price.split(':')[1] : '1'}`,
                _originalQuant: parseInt(child.split(':')[1]),
              }                
            }
          }
        })
      })
    }
  })
  await fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      items: groupData
    })
  }).then((response) => response.json()).then((parsedState) => {
      ajaxCart.load();
      document.querySelector('#cart-icon-bubble').click();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
  console.log(groupData)
  console.log(priceWVAT)
})